import React from 'react';
import {SubmissionDto, SubmissionApi} from '../../scaffold';
import {Button, Divider, Popconfirm, Space} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import {useInput} from 'react-hanger';
import Title from 'antd/lib/typography/Title';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import Text from 'antd/lib/typography/Text';

export default function SubmissionTeacherAudit(props: {submission: SubmissionDto; onSuccess: () => any}) {
  const remark = useInput('');
  const auditState = useOpenApiFpRequest(SubmissionApi, SubmissionApi.prototype.submissionTeacherAuditPost);
  function audit(isPassed: boolean) {
    auditState
      .request({
        teacherAuditModel: {
          id: props.submission.id || 0,
          isPassed,
          remark: remark.value,
        },
      })
      .then(props.onSuccess)
      .catch(CommonApiErrorHandler);
  }
  return (
    <div>
      <Title level={3}>导师审核</Title>
      <Text>意见和建议:</Text>
      <TextArea className={'m-t-5 m-b-20'} {...remark.eventBind} placeholder={'请输入意见和建议'} rows={5} />
      <Text className={'m-r-5'}>结论:</Text>
      <Space>
        <Popconfirm title={'确认通过申请吗'} onConfirm={() => audit(true)}>
          <Button type={'primary'} loading={auditState.loading}>
            通过
          </Button>
        </Popconfirm>
        <Popconfirm title={'确认不通过申请吗'} onConfirm={() => audit(false)}>
          <Button loading={auditState.loading} danger>
            不通过
          </Button>
        </Popconfirm>
      </Space>
      <Divider />
    </div>
  );
}
